export const PROJECT = {
    DOMAIN : 'www.idguardllc.com',
    MERCHAN_ID : 36,
    AMOUNT : '',
    BUILD_ORDER : '1',
    CAPTURA_DELAY : '0',
    PRODUCT_COUNT : '1',
    PRODUCT_ID : '3',
    PRODUCT_KU_1 : 'idGuard_product2',
    PRODUCT_QT_Y_1 : '1',
    BINCHECK : '1',
    SKIP : '1'
}